import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";

export class CWaterMark extends BasicCPCLArg<CWaterMark> {
  private value: number;

  constructor(options?: {

    value?: number
  }) {
    super();
    this.value = options?.value ?? 0;
  }

  clause(): CommandClause {
    return CPCLCommand.with(this.header())
      .appendNumber(this.value)
      .clause();
  }

  header(): string {
    return 'WAT';
  }
}



